<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: row; justify-content: flex-start;">
    <div style="display: flex; flex-direction: row; width: 100%;">
      <div style=" display: flex; flex-direction: row; margin-right: .5rem;">
        <div style="display: flex; flex-direction: column">
          <div>
            {{`${label}: `}}
            </div>
            <div>

            <font-awesome-icon v-if="expandable && !expanded" :icon="['fas','angle-double-down']"  @click="expanded=!expanded" />
            <font-awesome-icon v-else-if="expandable && expanded" :icon="['fas','angle-double-up']" @click="expanded=!expanded"/>
          </div>
        </div>
      </div>
      <select v-model="value" @change="handleInput($event)" :multiple="multiple" :id="`${identifier}-select`" :size="(expanded || !expandable) ? options.length : 4">
        <option v-for="option in options" :key="`${identifier}-${option}`" :value="option">
          {{option}}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSelectInput',
  props: {
    identifier: {
      required: true,
    },
    initialValue: {
      required: true,
    },
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      value: this.initialValue,
      expanded: false,
    }
  },
  methods: {
    handleInput (event) {
      let value
      if (this.multiple) {
        const element = document.getElementById(`${this.identifier}-select`)
        value = []
        for (let idx = 0; idx < element.options.length; idx += 1) {
          if (element.options[idx].selected) {
            value.push(element.options[idx].value)
          }
        }
      } else value = event.target.value
      this.$emit('change', value)
    },
  },
}
</script>

<style>

</style>
